const isBuildVersion = process.env.NODE_ENV === 'production';

const BASE_URL = isBuildVersion
	? window.location.origin
	: 'https://gufic.orderstack.xyz';

export default {
	LOGIN: BASE_URL + '/common/v0.1/login',
	LOGOUT: BASE_URL + '/common/v0.1/logout',

	/* Socket Conn eg
    UPLOAD_MODAL_SOCKET_EP: {
        BASE_URL,
        PATH: '/admin',
        QUERY: 'token='
    },
     */
	/* File download xls url SA A E for the entire report */
	BASE_URL,
	USER_DOWNLOAD_COMPLETE_REPORT: BASE_URL + '/ExportData/v0.1/ExportReport',
	EXTRACTED_DATA: BASE_URL + '/extractedData/v0.1/',
	EXTRACTED_DATA_RE_VERIFY: BASE_URL + '/mailmeta/v0.1/re-verify',
	EXTRACTED_DATA_RE_EXTRACT: BASE_URL + '/mailmeta/v0.1/re-extract',
	REJECTED_META: BASE_URL + '/rejectedMeta/v0.1/',
	FILE_META_BY_STOCKIST: BASE_URL + '/fileMeta/v0.1/',
	FILE_EXTRACTION: BASE_URL + '/mailmeta/v0.1/',
	FILE_EXTRACTION_VERIFY_CONFIG: BASE_URL + '/mailmeta/v0.1/verify/',
	FILE_EXTRACTION_EXTRACT_AND_SAVE_CONFIG: BASE_URL + '/mailmeta/v0.1/extract/',
	FILE_EXTRACTION_REJECT_VERIFY_CONFIG:
		BASE_URL + '/mailmeta/v0.1/reject-verify/',
	FILE_EXTRACTION_REJECT_EXTRACT_AND_SAVE_CONFIG:
		BASE_URL + '/mailmeta/v0.1/reject-extract/',
	FILE_EXTRACTION_SAVE_CONFIG: BASE_URL + '/mailmeta/v0.1/verify/',
	FILE_EXTRACTION_LOCK_FILE: BASE_URL + '/mailmeta/v0.1/lock-file/',
	FILE_EXTRACTION_UNLOCK_FILE: BASE_URL + '/mailmeta/v0.1/unlock-file/', // usae this end point to clear file lock
	UTILITY_OG_FILE: BASE_URL + '/utility/v0.1/original-file',
	UTILITY_PARSED_FILE: BASE_URL + '/utility/v0.1/parsed-file',
	UTILITY_TRANSFORMED_FILE: BASE_URL + '/utility/v0.1/transformed-file',
	UTILITY_ALTERNATE_TRANSFORMED_FILE:
		BASE_URL + '/utility/v0.1/alternated-transformed-file',
	UTILITY_FILE_META: BASE_URL + '/utility/v0.1/file-meta',
	UTILITY_EXTRACTED_OUTPUT: BASE_URL + '/utility/v0.1/extracted-output',
	UTILITY_GET_MAPPING: BASE_URL + '/utility/v0.1/get-mapping',
	UTILITY_REGISTER_MAPPING: BASE_URL + '/utility/v0.1/register-mapping',
	UTILITY_GET_EXTRACTED_DATA:
		BASE_URL + '/adminutility/v0.1/download-month-data',
	UTILITY_GET_MAIL_LOG: BASE_URL + '/adminutility/v0.1/download-mail-log',
	UTILITY_GET_OVERALL_SUMMARY: BASE_URL + '/utility/v0.1/overall-summary',
	UTILITY_GET_TREND_LINE: BASE_URL + '/utility/v0.1/trend-line',
	UTILITY_GET_CREATOR_WISE_META_COUNT:
		BASE_URL + '/utility/v0.1/creator-wise-analytics',
	UTILITY_GET_STOCKIST_WISE_SUMMARY:
		BASE_URL + '/utility/v0.1/stockist-analytics',
	UTILITY_GET_FILE_WISE_EXTRACTION_PERCENTAGE:
		BASE_URL + '/utility/v0.1/download-percentage-stats',
	UTILITY_FORCE_REJECT_FILE: BASE_URL + '/utility/v0.1/backend-reject',
	UTILITY_FORCE_REJECT_CONVERTABLE:
		BASE_URL + '/utility/v0.1/backend-reject-convertable',
	UTILITY_FORCE_SPLIT_FILE: BASE_URL + '/utility/v0.1/process-single-multi-pdf',
	UTILITY_FORCE_SPLIT_EXCEL_FILE:
		BASE_URL + '/utility/v0.1/process-single-multi-worksheet-excel',
	UTILITY_PUSH_LOGS: BASE_URL + '/adminutility/v0.1/push-logs-admin',
	UPLOAD_STOCKIST_MAPPING:
		BASE_URL + '/utility/v0.1/upload-for-stockist-mapping',
	UPLOAD_MODEL_INPUT: BASE_URL + '/adminutility/v0.1/upload-model-input',
	UPLOAD_CORRECT_STOCKIST_MAPPING:
		BASE_URL + '/utility/v0.1/upload-for-correct-mapping',
	DOWNLOAD_STOCKIST_MAPPING_ERROR:
		BASE_URL + '/utility/v0.1/download-stockist-mapping-error',
	DOWNLOAD_CORRECT_STOCKIST_MAPPING_ERROR:
		BASE_URL + '/utility/v0.1/download-corrected-mapping-error',
	STOCKIST: BASE_URL + '/stockist/v0.1/',
	UPDATE_STOCKIST_META: BASE_URL + '/stockist/v0.1/update',
	DELETE_STOCKIST_META: BASE_URL + '/stockist/v0.1/delete',
	GET_UNIDENTIFIED_FILES: BASE_URL + '/stockist/v0.1/unidentified-files',
	GET_ALL_STOCKIST: BASE_URL + '/stockist/v0.1/all-stockists',
	VERIFY_STOCKIST_META: BASE_URL + '/stockist/v0.1/verify-stk-mapping',
	APPLY_STOCKIST_MAPPING: BASE_URL + '/stockist/v0.1/update-stk-mapping',
	FORCE_STOCKIST_MAPPING: BASE_URL + '/stockist/v0.1/force-stk-mapping',
	HIDE_FILE_FOR_MAPPING: BASE_URL + '/stockist/v0.1/hide-stk-mapping',
	EXTRACTED_DATA_ROW: BASE_URL + '/ExtractedData/v0.1/',
	EXTRACTED_DATA_ROW_VALIDITY: BASE_URL + '/ExtractedData/v0.1/row-validity',
	UPDATE_FLAG: BASE_URL + '/MailMeta/v0.1/update-flag',
	CHECK_IF_PYTHON_SCRIPT_CONVERTABLE:
		BASE_URL + '/Utility/v0.1/is-python-script-convertable',
	DOWNLOAD_PYTHON_SCRIPT_CONVERTABLE_OUTPUT:
		BASE_URL + '/Utility/v0.1/python-script-convertable-output',
	DOWNLOAD_PDF_ML_API_CONVERTABLE_OUTPUT:
		BASE_URL + '/Utility/v0.1/pdf-ml-model-convertable-output',
	DOWNLOAD_PDF_GEMINI_CONVERTABLE_OUTPUT:
		BASE_URL + '/Utility/v0.1/pdf-gemini-convertable-output',
	DOWNLOAD_XLS_TO_XLSX_CONVERTABLE_OUTPUT:
		BASE_URL + '/Utility/v0.1/python-script-convertable-xls',
	REVERT_TO_ORIGNAL:
		BASE_URL + '/Converters/v0.1/revert-reintroduction-and-map-file-manually',
	REVERT_TO_META_NOT_FOUND:
		BASE_URL + '/Converters/v0.1/revert-to-meta-not-found',
	AI_GENERATED_HEADER_MAPPING:
		BASE_URL + '/FileMeta/v0.1/generate-header-mapping-from-ml-model',
};
